export default function spacingThousands(number) {
  return number.toLocaleString('en').replace(/,/g, ' ');
}
